import cn from 'classnames';

import coinLeft from '../../assets/coin_left.png';
import coinRight from '../../assets/coins_right.png';

import styles from './HeroBackgroundDecor.module.scss';

export const HeroBackgroundDecor = () => {
  return (
    <div className={styles.heroDecor}>
      <img
        alt="Coin Left"
        src={coinLeft}
        className={cn(styles.coin, styles.coinLeft)}
      />
      <img
        alt="Coins Right"
        src={coinRight}
        className={cn(styles.coin, styles.coinsRight)}
      />
    </div>
  );
};
